import { render } from "./index.vue?vue&type=template&id=617cf4e0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabInformation/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "617cf4e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('617cf4e0', __exports__)) {
    console.log('reload')
    api.reload('617cf4e0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=617cf4e0", () => {
    console.log('re-render')
    api.rerender('617cf4e0', render)
  })

}


export default __exports__